import React, { useEffect, useMemo } from 'react';
import { useRootStore } from 'store';
import { TablePaginatedV8, CellLeftV8, TableCellV8, CellCenterV8 } from 'motion-components';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { gql, useLazyQuery } from '@apollo/client';

export const gqlGetCollPointContainers = gql`
  query getContainersOfCollectionPoint($collectionPointId: Int) {
    getContainersOfCollectionPoint(collectionPointId: $collectionPointId) {
      data {
        containerTypeId
        containerTypeName
        containersQty
      }
      recordCount
    }
  }
`;

export const ContainersStocksTabPage = ({ collectionPointId }) => {
  const [getCollPointContainers, { data }] = useLazyQuery(gqlGetCollPointContainers, {
    fetchPolicy: 'cache-first',
  });

  console.log('$$$$', data);

  useEffect(() => {
    getCollPointContainers({ variables: { collectionPointId } });
  }, [collectionPointId]);

  return (
    <>
      <ContainersStocksGridTable data={data?.getContainersOfCollectionPoint?.data} />
    </>
  );
};

/* ----------- Component ------------------ */
const ContainersStocksGridTable = ({ data }) => {
  const location = useLocation<any>();
  const history = useHistory();
  const { appStore, tableStore } = useRootStore();
  const { t } = useTranslation();

  // Define Columns (Without Weight)
  const columns = useMemo(
    () => [
      {
        id: 'containertype.name',
        header: t('Τύπος Συσκευασίας'),
        columnName: t('Τύπος Συσκευασίας'),
        accessorKey: 'containerTypeName',
        orderByField: 'containerTypeName',
        cell: CellLeftV8,
        size: 5,
      },
      {
        id: 'containersQty',
        header: t('Πλήθος Συσκευασιών'),
        columnName: t('Πλήθος Συσκευασιών'),
        accessorKey: 'containersQty',
        orderByField: 'containersQty',
        cell: CellCenterV8,
        meta: { type: 'float' },
        size: 30,
      },
    ],
    [t],
  );

  return (
    <>
      <h5 className="form-group-title" style={{ marginBottom: '0px' }}>
        {t('Απόθεμα Συσκευασιών')}
      </h5>

      {/* TableGrid */}
      {data ? (
        <TablePaginatedV8
          loading={false}
          id="containers-grid"
          appStore={appStore}
          tableStore={tableStore}
          key="grid"
          columns={columns as any}
          data={data}
          dataCount={data.length}
          topBorderRadius={false}
          initSorting={[{ id: 'containertype.name', desc: true }]}
        />
      ) : (
        <div style={{ height: '200px' }}></div>
      )}
    </>
  );
};

